import { render, staticRenderFns } from "./ProductParamSlider.vue?vue&type=template&id=01a37145"
import script from "./ProductParamSlider.vue?vue&type=script&lang=js"
export * from "./ProductParamSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductParamSlider.vue?vue&type=style&index=0&id=01a37145&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports